<div class="progress-component">
    <div class="progress-date">
        <span>{{startDate}}</span>
        <span class="end-date">{{endDate}}</span>
    </div>
    <div class="progress-meter">
        <div class="progress-fill" [ngStyle]="{width: percentageValue + '%', background: color}"></div>
    </div>
</div>
